
module dgUtils {
    angular.module('dgUtils', []);
}